import { Feature } from '@app/core/interfaces/c5/feature';
import { SpecialTarget } from '@app/core/interfaces/c5/special-target';
import { Trunk } from './portal/trunk';

export interface TrunkProfile {
  default: boolean;
  description: string;
  id: number;
  json: {
    ddiData: Record<string, any>;
    features: Feature[];
    specialTarget: SpecialTarget;
  };
  name: string;
  cloudType?: TrunkCloudType;
}

export enum TrunkCloudType {
  MSTEAMS_OC = 'MSTEAMS_OC',
  MSTEAMS = 'MSTEAMS',
  GENESYS = 'GENESYS',
}

export function isTeamsTrunk(trunkOrProfile: Trunk | TrunkProfile | null | undefined): boolean {
  if (trunkOrProfile == null) {
    return false;
  }
  return (
    trunkOrProfile.cloudType === TrunkCloudType.MSTEAMS ||
    trunkOrProfile.cloudType === TrunkCloudType.MSTEAMS_OC
  );
}
